import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Background from "../assets/images/background.jpg";
import Header1 from './public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

class Continue extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }


    render(){
        return(
            <div>
              <Header1></Header1>
                <Content style={{ padding: '0 50px' }}>

                <div style={{background: `url(${Background}) no-repeat center center`,height:300, width: "100%",backgroundSize: "cover",}}>
                <div style={{textAlign:"center"}}>
                <br></br><br></br>
                  <txt style={{fontSize:60,fontWeight:'bold'}}>THE CIITOOL PLATFORM</txt> <br></br><br></br>
                  <txt style={{fontSize:40,fontWeight:'bold',}}>Improving the clinical cure of cancer through medical imaging analysis</txt>
                  </div>
                </div>
                <txt style={{fontSize:30,fontWeight:'bold'}}>Write comments to us if there is any question!</txt>
                <br></br>
                <txt style={{fontSize:30,fontWeight:'bold'}}>Email: ciitool.contact@gmail.com</txt>
                </Content>
            </div>
        )
    }
}
export default Continue;
